export const MANHEIM_MAIL = 'manheimMail';
export const MANHEIM_MOBILE_TELEPHONE = 'manheimMobileTelephone';
export const MANHEIM_MAIL_FLAG = 'emailIsVerified';
export const MANHEIM_MOBILE_TELEPHONE_FLAG = 'phoneIsVerified';
export const VALID = 'VALID';
export const INVALID = 'INVALID';
export const NORMAL = 'NORMAL';
export const MAIL_UPDATE_ERROR = 'Email is linked to another account.';
export const MAIL_UPDATE_SUCCESS =
  'Email sent to complete the verification process';
export const PHONE_UPDATE_SUCCESS =
  'Phone number can be verified by client the next time they log in.';
export const PHONE_UPDATE_ERROR = 'Phone number is linked to another account.';

export const MODAL_ONLY_PHONE_MESSAGE =
  'The phone number has been assigned to another username. Please confirm with the client before reassigning it.';
export const MODAL_ONLY_MAIL_MESSAGE =
  'The email has been assigned to another username. Please confirm with the client before reassigning it.';
export const MODAL_BOTH_MESSAGE =
  'The phone number and email have already been assigned. Please confirm with the client before reassigning one or both.';

export const MAIL_UPDATE_SUSCESS_OBJ = {
  type: VALID,
  variant: 'success',
  value: MAIL_UPDATE_SUCCESS,
};
export const PHONE_UPDATE_SUSCESS_OBJ = {
  type: VALID,
  variant: 'success',
  value: PHONE_UPDATE_SUCCESS,
};
export const MAIL_UPDATE_FAILED_OBJ = {
  type: INVALID,
  variant: 'error',
  value: MAIL_UPDATE_ERROR,
};
export const PHONE_UPDATE_FAILED_OBJ = {
  type: INVALID,
  variant: 'error',
  value: PHONE_UPDATE_ERROR,
};

export const MAIL_UPDATE_IDLE_OBJ = {
  type: NORMAL,
};
export const PHONE_UPDATE_IDLE_OBJ = {
  type: NORMAL,
};

export const IDLE = 'IDLE';
export const SHOULD_UPDATE = 'SHOULD_UPDATE';
export const NEED_CONFIRM = 'NEED_CONFIRM';
export const DENY = 'DENY';

export const MAIL_VERIFY_SUSCESS_OBJ = {
  type: VALID,
  variant: 'success',
  value: 'Email sent to complete the verification process',
};
